import { TStatus } from "./types";

export const statusToActiveText: Record<TStatus, string> = {
  error: "Inactive",
  success: "Active",
  warning: "",
  disabled: "",
  purple: "",
  blue: "",
};
export const activeTextToStatus: Record<string, TStatus> = {
  inactive: "error",
  deactivated: "error",
  active: "success",
};
